import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast } from "#app/notifications";
import { createQuoteRequest } from "#modules/quoteRequests/infra/createQuoteRequest.api";

export const useCreateQuoteRequest = () => {
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: createQuoteRequest,

    onError: (error) => {
      if (error instanceof AxiosError && error.response?.data?.message) {
        const { message } = error.response.data;
        logger.error(error.message);
        showErrorToast({ title: message });
      } else {
        logger.error("Error while creating quote request");
        showErrorToast({
          title: "Une erreur est survenue lors de la création de la demande.",
        });
      }
    },
  });

  return { createQuoteRequest: mutateAsync, ...rest };
};
